import { io } from 'socket.io-client'

const SOCKET_URL = process.env.VUE_APP_SOCKET_URL

export default SOCKET_URL ? io(SOCKET_URL) : io()
